import { createReducer, on } from '@ngrx/store';

import { InlineFilterActions } from './inline-filter.actions';
import { FilterObjectType, FilterSavedState, InlineFilterState, SectionFiltersPayload } from './inline-filter.models';

export const initialInlineFilterState: InlineFilterState = {
    persistedStates: {},
    workingStates: {},
    enrichedConfigs: {},
};

const writeEntry = (root: SectionFiltersPayload, objectType: FilterObjectType, section: string, value: FilterSavedState): SectionFiltersPayload => ({
    ...root,
    [objectType]: {
        ...root[objectType],
        [section]: value,
    },
});

export const inlineFilterReducer = createReducer(
    initialInlineFilterState,

    on(
        InlineFilterActions.setEnrichedConfigs,
        (state, { enriched }): InlineFilterState => ({
            ...state,
            enrichedConfigs: enriched,
        })
    ),

    on(
        InlineFilterActions.setAllFilterStates,
        (state, { states }): InlineFilterState => ({
            ...state,
            persistedStates: states ?? {},
            workingStates: states ?? {},
        })
    ),

    on(
        InlineFilterActions.updateFilterState,
        (state, { objectType, section, state: filterState }): InlineFilterState => ({
            ...state,
            workingStates: writeEntry(state.workingStates, objectType, section, filterState),
        })
    ),

    on(
        InlineFilterActions.saveFilterStateSuccess,
        (state, { objectType, section, state: filterState }): InlineFilterState => ({
            ...state,
            persistedStates: writeEntry(state.persistedStates, objectType, section, filterState),
        })
    ),

    on(
        InlineFilterActions.revertFilterState,
        (state, { objectType, section }): InlineFilterState => ({
            ...state,
            workingStates: writeEntry(state.workingStates, objectType, section, state.persistedStates?.[objectType]?.[section] ?? {}),
        })
    ),

    on(
        InlineFilterActions.clearFilterState,
        (state, { objectType, section }): InlineFilterState => ({
            ...state,
            workingStates: writeEntry(state.workingStates, objectType, section, {}),
        })
    ),

    on(InlineFilterActions.reset, (): InlineFilterState => initialInlineFilterState)
);
